import { GtmEventsEnum, gtmEvent } from '@modules/gtm';

import { MenuConfigItem } from '../../types';

// create a click handler for Google tag managers
export const gtmClickLink = (type: MenuConfigItem['gtmType']) => {
  if (type) gtmEvent(GtmEventsEnum.click, { type });
};
